<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;"> {{$t("buySubscription")}} </span>
                </v-card-title>
                <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>

                <v-divider></v-divider>

                <v-card-text class="pb-0 pt-1">
                    <p v-if="$i18n.locale == 'ru'" class="text-xs-center">
                        Выберете желаемую подписку и получите полный доступ к сервису с поддержкой!
                    </p>
                    <p v-else class="text-xs-center">
                        Choose your desired subscription and get full access to the service with support!
                    </p>
                </v-card-text>

                <v-container fluid class="pt-0">
                    <v-select
                        v-model="selectedSubscription"
                        :items="subscription"
                        item-text="title"
                        item-value="id"
                        :label="$t('subscription')"
                        hide-details
                        class="mb-3"
                        :disabled="progressBarVisible"
                    ></v-select>
                    <v-select
                        v-model="selectedPeriod"
                        :items="period"
                        item-text="title"
                        item-value="id"
                        :label="$t('period')"
                        hide-details
                        class="mb-3"
                        :disabled="progressBarVisible"
                    ></v-select>
                    <v-text-field
                        v-model="mail"
                        :label="$t('eMailAddress')"
                        :hint="$t('eMailHint').toLowerCase()"
                        persistent-hint
                        class="mb-2"
                        :disabled="progressBarVisible"
                    >
                    </v-text-field>

                    <v-select
                        v-model="selectedPaymentType"
                        :items="paymentTypes"
                        item-text="title"
                        item-value="id"
                        :label="$t('paymentType')"
                        hide-details
                        class="mb-3"
                        :disabled="progressBarVisible"
                    ></v-select>

                    <template v-if="selectedPaymentType == 2">
                        <v-divider></v-divider>
                        <v-text-field
                            v-model="companyName"
                            :label="$t('companyName')"
                            hide-details
                            class="mb-2 mt-1"
                            :disabled="progressBarVisible"
                        >
                        </v-text-field>
                        <v-text-field
                            v-model="inn"
                            label="ИНН"
                            hide-details
                            class="mb-2"
                            :disabled="progressBarVisible"
                        >
                        </v-text-field>
                        <v-text-field
                            v-model="kpp"
                            label="КПП"
                            hide-details
                            class="mb-2"
                            :disabled="progressBarVisible"
                        >
                        </v-text-field>
                        <v-text-field
                            v-model="address"
                            :label="$t('address')"
                            placeholder="163002, Архангельская обл., г. Архангельск, пр-кт Новгородский, д. 32, к. 4"
                            hide-details
                            class="mb-2"
                            :disabled="progressBarVisible"
                        >
                        </v-text-field>
                    </template>
                </v-container>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="selectedPaymentType == 2"
                        color="success"
                        @click="requestBill"
                        :disabled="selectedSubscription == null || selectedPeriod == null || selectedPaymentType == null
                                || companyName == '' || inn == '' || kpp == '' || address == '' || progressBarVisible"
                    >{{  $t("requestBill") }}</v-btn>
                    <v-btn
                        v-else
                        color="success"
                        @click="goToPayment"
                        :disabled="selectedSubscription == null || selectedPeriod == null || selectedPaymentType == null || progressBarVisible"
                    >{{  $t("goToPayment") }}</v-btn>

                    <v-btn color="error" @click="dialog = false">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
            <message-box ref="MessageBox"/>
        </v-dialog>
    </v-layout>
</template>

<script>
    import MessageBox from "./MessageBox";

    export default {
        name: "SubmitApplicationDialog",

        components: {
            MessageBox,
        },

        data () {
            return {
                dialog:               false,

                companyName:          "",
                inn:                  "",
                kpp:                  "",
                address:              "",
                mail:                 "",
                subscription:         [],
                selectedSubscription: null,
                period:               [],
                progressBarVisible:   false,
                selectedPeriod:       null,
                price:                "",

                paymentTypes:         [],
                selectedPaymentType:  null,

                user:                 {}
            }
        },

        watch: {

            dialog: function (val) {
                if (val) {
                    if (this.user.billNumber != null) {
                        let bill = JSON.parse(this.user.billParams);
                        this.showMessageBox(this.$t("attention"), `${this.$t("notes.billExist")} Счет ${this.user.billNumber} от ${bill.date} (${bill.type} ${bill.period})`);
                    }
                }
            }
        },

        async mounted () {
            this.applyLocale();
            await this.getUserInfo();

            this.$watch(
                "$refs.MessageBox.dialog",
                (val) => {
                    if (!val) {
                        if (this.selectedPaymentType != null) {
                            this.dialog = false;
                        }
                    }
                }
            );
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.subscription = [
                    {id: 0, title: this.$t("subscriptionPlans.standard")},
                    {id: 1, title: this.$t("subscriptionPlans.standardPlus")},
                    {id: 2, title: this.$t("subscriptionPlans.professional")}
                ];
                this.period = [
                    {id: 0, title: this.$t("subscriptionPlans.quarterly")},
                    {id: 1, title: this.$t("subscriptionPlans.yearly")}
                ];
                this.paymentTypes = [
                    {id: 0, title: this.$t("paymentTypes.bankcardAndSbp")},
                    // {id: 1, title: this.$t("paymentTypes.sbp")},
                    {id: 2, title: this.$t("paymentTypes.bill")}
                ];
            },

            /**
             *  Получение информации об авторизованном пользователе
             */
             getUserInfo () {
                this.axios.get(`${this.$config.apiURL}users/logged_in/`, { withCredentials: true })
                .then(response => {
                    if (response.data.user.rows == undefined) { return; }

                    let userInfo = response.data.status == "success"
                        ? response.data.user.rows[0]
                        : {};

                    this.user.companyId = userInfo.Company.id;
                    this.user.companyName = userInfo.Company.Name.trim();
                    this.user.inn = userInfo.Company.Inn !== null
                        ? userInfo.Company.Inn.trim()
                        : "";
                    this.user.kpp = userInfo.Company.Kpp !== null
                        ? userInfo.Company.Kpp.trim()
                        : "";
                    this.user.address = userInfo.Company.Address !== null
                        ? userInfo.Company.Address.trim()
                        : "";

                    this.user.userId = userInfo.id;
                    this.user.firstName = userInfo.FirstName !== null
                                    ? userInfo.FirstName.trim() + " "
                                    : "";
                    this.user.middleName = userInfo.MiddleName !== null
                                    ? userInfo.MiddleName.trim() + " "
                                    : "";
                    this.user.lastName = userInfo.LastName !== null
                                    ? userInfo.LastName.trim() + " "
                                    : "";
                    this.user.eMail = userInfo.EMail.trim();

                    this.user.billNumber = userInfo.Company.BillNumber;
                    this.user.billParams = userInfo.Company.BillParams;

                    this.mail = this.user.eMail;
                    this.companyName = this.user.companyName;
                    this.inn = this.user.inn;
                    this.kpp = this.user.kpp;
                    this.address = this.user.address;


                }).catch(error => {
                    this.$debug.error(error);

                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserInfo") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserInfo") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserInfo"));
                    }
                });
            },

            /**
             *
             */
            async goToPayment () {
                this.progressBarVisible = true;

                let subscriptionPrice = 0;

                if (this.selectedSubscription == 0 && this.selectedPeriod == 0) {
                    subscriptionPrice = this.$config.prices.standard.quarter.num;
                } else if (this.selectedSubscription == 0 && this.selectedPeriod == 1) {
                    subscriptionPrice = this.$config.prices.standard.year.num;
                } else if (this.selectedSubscription == 1 && this.selectedPeriod == 0) {
                    subscriptionPrice = this.$config.prices.standardPlus.quarter.num;
                } else if (this.selectedSubscription == 1 && this.selectedPeriod == 1) {
                    subscriptionPrice = this.$config.prices.standardPlus.year.num;
                } else if (this.selectedSubscription == 2 && this.selectedPeriod == 0) {
                    subscriptionPrice = this.$config.prices.professional.quarter.num;
                } else if (this.selectedSubscription == 2 && this.selectedPeriod == 1) {
                    subscriptionPrice = this.$config.prices.professional.year.num;
                }

                await this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}subscriptions/requestPayment/`,
                    data: {
                        paymentType:    this.selectedPaymentType,
                        companyId:      this.user.companyId,
                        companyName:    this.user.companyName,
                        inn:            this.inn,
                        user:           `${this.user.lastName} ${this.user.firstName} ${this.user.middleName}`,
                        mail:           this.mail,
                        subscription:   this.subscription[this.selectedSubscription].title,
                        period:         this.period[this.selectedPeriod].title,
                        price:          subscriptionPrice
                    },
                    withCredentials: true
                }).then(response => {
                    let r_data = response.data;

                    if (r_data.status == "success") {
                        //this.showMessageBox(this.$t("attention"), this.$t("notes.successPaymentRequest"));
                        //this.showMessageBox("", this.$t("notes.successApplicationSubmition"));
                        window.location.replace(r_data.paymentURL);
                        //window.open(r_data.paymentURL, '_blank');
                    } else {
                        switch (r_data.result) {
                            case "captcha_api_call_failed":
                                this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                                break;
                            case "captcha_check_negative":
                                this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                                break;
                            default:
                                this.showMessageBox(this.$t("error"), this.$t("cantSendMessage"));
                        }
                    }

                    this.progressBarVisible = false;
                }).catch(() => {
                    this.progressBarVisible = false;
                    this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                });

                //this.dialog = false;
            },

            async requestBill () {
                this.progressBarVisible = true;

                let price;

                if (this.selectedSubscription == 0 && this.selectedPeriod == 0) {
                    price = this.$config.prices.standard.quarter;
                } else if (this.selectedSubscription == 0 && this.selectedPeriod == 1) {
                    price = this.$config.prices.standard.year;
                } else if (this.selectedSubscription == 1 && this.selectedPeriod == 0) {
                    price = this.$config.prices.standardPlus.quarter;
                } else if (this.selectedSubscription == 1 && this.selectedPeriod == 1) {
                    price = this.$config.prices.standardPlus.year;
                } else if (this.selectedSubscription == 2 && this.selectedPeriod == 0) {
                    price = this.$config.prices.professional.quarter;
                } else if (this.selectedSubscription == 2 && this.selectedPeriod == 1) {
                    price = this.$config.prices.professional.year;
                }

                await this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}subscriptions/requestBill/`,
                    data: {
                        companyId:      this.user.companyId,
                        companyName:    this.companyName,
                        inn:            this.inn,
                        kpp:            this.kpp,
                        address:        this.address,
                        user:           `${this.user.lastName} ${this.user.firstName} ${this.user.middleName}`,
                        mail:           this.mail,
                        subscription:   this.subscription[this.selectedSubscription].title,
                        period:         this.period[this.selectedPeriod].title,
                        priceNum:       price.num,
                        priceStr:       price.str,
                        priceNumStr:    price.numStr
                    },
                    withCredentials: true
                }).then(response => {
                    let r_data = response.data;

                    if (response.status == 200) {
                        this.showMessageBox("", this.$t("notes.successBillSubmition"));

                        // const blob = new Blob([r_data], { type: "application/pdf" });
                        // console.log(blob)
                        // const link = document.createElement("a");
                        // link.href = window.URL.createObjectURL(blob);
                        // link.download = "test.pdf";
                        // link.click();
                        //window.open(href);

                    } else {
                        switch (r_data.result) {
                            case "captcha_api_call_failed":
                                this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                                break;
                            case "captcha_check_negative":
                                this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                                break;
                            default:
                                this.showMessageBox(this.$t("error"), this.$t("cantSendMessage"));
                        }
                    }

                    this.progressBarVisible = false;
                }).catch(() => {
                    this.progressBarVisible = false;
                    this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                });

                //this.dialog = false;
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
        }
    }
</script>

